<template>
	<div class="">
		<base-page-heading
			title="Regions"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="regionsShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<RegionTable @routeRegion="routeRegion" />
		</div>
	</div>
</template>
